<div class="content-body">
  <form [formGroup]="fundTransferForm">
    <div class="d-flex gap-30 align-items-center">
      <div class="form-field datepicker">
        <p>Transfer Date <span class="text-danger-300">*</span></p>
        <mat-form-field appearance="fill">
          <input
            matInput
            [min]="minInvoiceDate"
            [max]="maxInvoiceDate"
            formControlName="transferDate"
            [matDatepicker]="transferDate"
            autocomplete="off"
            (change)="commonService.validateDate($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="transferDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #transferDate></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="
            commonService.checkDateValidation(
              fundTransferForm.get('transferDate')
            ).invalidFinancialYear
          "
        >
          {{ notificationMessage.validPeriodDateMessage }}
        </mat-error>

        <mat-error
          *ngIf="
            commonService.checkDateValidation(
              fundTransferForm.get('transferDate')
            ).lockedFinancialYear
          "
        >
          {{ notificationMessage.lockedAccoutingPeriodDateMessage }}
        </mat-error>
      </div>
      <div class="form-field">
        <p>Amount<span class="text-danger-300">*</span></p>
        <mat-form-field>
          <input
            matInput
            zeroNotAllowed
            formControlName="amount"
            autocomplete="off"
            required
            maxlength="{{ maxLength.maxLength25 }}"
            allowDecimal
          />
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex gap-30 align-items-center">
      <div class="form-field">
        <p>Transfer From Fund <span class="text-danger-300">*</span></p>
        <ng-select
          #fundFrom
          (focus)="fundFrom.open()"
          (valueChange)="fundFrom.close()"
          [disableOptionCentering]="true"
          formControlName="transferFrom"
          panelClass="mat-select-position"
          (change)="getFromBanksByFundId()"
        >
          <ng-option
            *ngFor="let option of fundfromTransList"
            [value]="option.id"
          >
            <div class="clamp" title="{{ option.name }}">{{ option.name }}</div>
          </ng-option>
        </ng-select>
      </div>
      <div class="form-field">
        <p>Transfer To Fund <span class="text-danger-300">*</span></p>
        <ng-select
          #transferTo
          (focus)="transferTo.open()"
          (valueChange)="transferTo.close()"
          [disableOptionCentering]="true"
          formControlName="transferTo"
          panelClass="mat-select-position"
          (change)="getToBanksByFundId()"
        >
          <ng-option *ngFor="let option of fundToTransList" [value]="option.id">
            <div class="clamp" title="{{ option.name }}">{{ option.name }}</div>
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="d-flex gap-30 align-items-center">
      <div class="form-field">
        <div class="d-flex align-items-center gap-5 mb-10">
        <p class="m-0">Transfer From Bank </p>
        <mat-icon fontSet="material-icons-outlined"
                matTooltip="select a bank in order to have a agreed fund wise balance sheet when making a fund transfer" class="info-icon">info</mat-icon>
                </div>
        <ng-select
          #fundFromBank
          (focus)="fundFromBank.open()"
          (valueChange)="fundFromBank.close()"
          [disableOptionCentering]="true"
          formControlName="transferFromBank"
          panelClass="mat-select-position"
        >
          <ng-option
            *ngFor="let option of fromBankData"
            [value]="option.id"
          >
            <div class="clamp" title="{{ option.name }}">{{ option.name }}</div>
          </ng-option>
        </ng-select>
      </div>
      <div class="form-field">
        <div class="d-flex align-items-center gap-5 mb-10">
        <p class="m-0">Transfer To Bank </p>
        <mat-icon fontSet="material-icons-outlined"
                matTooltip="select a bank in order to have a agreed fund wise balance sheet when making a fund transfer" class="info-icon">info</mat-icon>
                </div>
        <ng-select
          #transferToBank
          (focus)="transferToBank.open()"
          (valueChange)="transferToBank.close()"
          [disableOptionCentering]="true"
          formControlName="transferToBank"
          panelClass="mat-select-position"
        >
          <ng-option *ngFor="let option of toBankData" [value]="option.id">
            <div class="clamp" title="{{ option.name }}">{{ option.name }}</div>
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="form-field wp-100 textarea">
      <p>Notes</p>
      <mat-form-field>
        <textarea
          maxlength="{{ maxLength.maxLength2000 }}"
          matInput
          formControlName="note"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
